import ObjectsCell from './ObjectsCell';

export default ObjectsCell;
